var config = {
    apiUrlregister :'https://crypto-auth.onrender.com/api/v1/register',
    apiUrllogin :'https://crypto-auth.onrender.com/api/v1/login',
    apiUrlprofile : 'https://crypto-auth.onrender.com/api/v1/profile',
    apiUrlgetfav : 'https://crypto-fav.onrender.com/api/v1/getfav',
    apiUrlremovefav : 'https://crypto-fav.onrender.com/api/v1/removefav',
    apiUrladdfav : 'https://crypto-fav.onrender.com/api/v1/addfav'

}

export default config;